@if (model.displayDistance) {
    <div class="row mb-3 align-items-center">
        <label
            class="col-12 col-md-2 col-form-label text-start text-md-end"
            for="distance"
            translate="CONFIRMATION_EXPENSES_DISTANCE_LABEL"
        ></label>
        <div class="col-12 col-md-auto">
            <pace-core-text-input
                id="distance"
                name="distance"
                [(model)]="model.distance"
                [parentForm]="parentForm"
                [ariaLabel]="'CONFIRMATION_EXPENSES_DISTANCE_LABEL' | translate"
            ></pace-core-text-input>
        </div>
    </div>
}
@if (model.displayExpenses) {
    <hr class="separator" />
    <div class="row mb-3">
        <label
            class="col-4 col-md-2 col-form-label text-start text-md-end"
            translate="CONFIRMATION_EXPENSES_LABEL"
        ></label>
        <div class="col-md-10 mb-3" [ngClass]="model.expenses.value.length ? 'col-12' : 'col-8'">
            <pace-expenses-list
                [notificationIdentifier]="model.notificationId"
                [expenses]="model.expenses"
                [parentForm]="parentForm"
            ></pace-expenses-list>
        </div>
    </div>
}
@if (model.displayAdditionalTravelCost) {
    <div class="row align-items-center">
        <label
            class="col-9 col-sm-3 col-md-auto col-lg-2 col-form-label text-nowrap text-start text-sm-end"
            translate="CONFIRMATION_EXPENSES_ADDITIONAL_TRAVEL_COST_LABEL"
        >
        </label>
        <div class="col-3 d-flex justify-content-end justify-content-md-start">
            <pace-core-checkbox-input
                [(model)]="model.additionalTravelExpenses"
                [parentForm]="parentForm"
                id="additionalTravelExpenses"
            >
            </pace-core-checkbox-input>
        </div>
    </div>
}
